var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 115,
    viewBox: "0 0 116 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    id: "Group 316"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 57.3738,
    y1: 1.09278e-8,
    x2: 57.3738,
    y2: 114.862,
    stroke: "#083342",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    x1: 115.03,
    y1: 57.2907,
    x2: -0.0000534276,
    y2: 57.2907,
    stroke: "#083342",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPlus);
export default __webpack_public_path__ + "static/media/vector-plus.2abd35e694e833b473f7b3b91ce991a8.svg";
export { ForwardRef as ReactComponent };